<template>
  <li role="presentation"><header class="dropdown-header"><slot/></header></li>
</template>

<script setup>
// Replaces bootstrap-vue's <b-dropdown-header> with the same markup.
defineOptions({
  name: 'BDropdownHeader',
})
</script>
